import styled from 'styled-components';

export const TruncatedContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xs};
  max-width: 100%;
  position: relative;
`;

export const InfoIcon = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 14px;
  height: 14px;

  &:hover svg circle {
    fill: ${({ theme }) => theme.colors.greyLight};
    stroke: ${({ theme }) => theme.colors.darkGrey};
  }

  &:active svg circle {
    fill: ${({ theme }) => theme.colors.greySilver};
  }

  /* Mejor área de toque para dispositivos móviles */
  @media (hover: none) and (pointer: coarse) {
    min-width: 24px;
    height: 24px;

    &::before {
      content: '';
      position: absolute;
      width: 24px;
      height: 24px;
      background: transparent;
    }
  }
`;

export const TooltipContainer = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  z-index: ${({ theme }) => theme.zIndex.tooltip};
  background: ${({ theme }) => theme.colors.darkGrey};
  color: ${({ theme }) => theme.colors.white};
  padding: ${({ theme }) => theme.spacing.xs} ${({ theme }) => theme.spacing.s};
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  font-size: ${({ theme }) => theme.fontSize.XS};
  line-height: 1.5;
  max-width: 300px;
  word-wrap: break-word;
  box-shadow: ${({ theme }) => theme.shadows.md};
  margin-top: ${({ theme }) => theme.spacing.xxxs};

  /* Flecha del tooltip */
  &::before {
    content: '';
    position: absolute;
    top: -4px;
    left: ${({ theme }) => theme.spacing.s};
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-bottom: 4px solid ${({ theme }) => theme.colors.darkGrey};
  }

  /* Responsive para tablets */
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 90vw;

    &::before {
      display: none;
    }
  }
`;

export const TooltipText = styled.span`
  display: block;
  white-space: normal;
`;
